import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBudgetStep6 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 540 376",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M540 326.992H0V327.262H540V326.992Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M120.593 336.054H84.8232V336.324H120.593V336.054Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M176.58 343.841H143.996V344.111H176.58V343.841Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M102.708 346.076H61.3984V346.346H102.708V346.076Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M485.892 345.493H468.72V345.763H485.892V345.493Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M465.253 345.493H422.787V345.763H465.253V345.493Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M302.756 335.913H270V336.183H302.756V335.913Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M385.311 335.913H307.443V336.183H385.311V335.913Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M450.706 191.172H410.476V326.993H450.706V191.172Z",
			fill: "#E6E6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M444.02 326.992H450.705V314.767H436.989L444.02 326.992Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M286.945 191.172H246.715V326.993H286.945V191.172Z",
			fill: "#E6E6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M450.716 191.172H281.113V322.295H450.716V191.172Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M445.521 196.982H286.308V232.946H445.521V196.982Z",
			fill: "#E6E6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M373.432 208.16H358.387C351.907 208.16 345.611 203.722 341.107 195.892H390.69C386.208 203.722 379.966 208.16 373.432 208.16Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M287.809 326.992H281.113V314.767H294.829L287.809 326.992Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M445.521 238.757H286.308V274.721H445.521V238.757Z",
			fill: "#E6E6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M373.432 249.88H358.387C351.907 249.88 345.611 245.452 341.107 237.611H390.69C386.208 245.495 379.966 249.88 373.432 249.88Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M445.521 280.531H286.308V316.495H445.521V280.531Z",
			fill: "#E6E6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M373.432 291.698H358.387C351.907 291.698 345.611 287.259 341.107 279.429H390.69C386.208 287.259 379.966 291.698 373.432 291.698Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M469.033 15.0342H295.305V99.3606H469.033V15.0342Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M475.297 15.0342H298.231V99.3606H475.297V15.0342Z",
			fill: "#F5F5F5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M466.538 92.3519V22.0547L307 22.0547V92.3519L466.538 92.3519Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M416.405 161.385C419.537 128.985 421.708 76.3025 420.023 58.6985C419.991 58.3967 419.895 58.1051 419.742 57.8427C419.59 57.5803 419.384 57.353 419.137 57.1757C418.811 56.9365 418.423 56.794 418.019 56.7645C417.615 56.735 417.211 56.8197 416.853 57.0089C416.495 57.1981 416.197 57.4842 415.994 57.8345C415.79 58.1848 415.69 58.5852 415.703 58.9901C415.995 67.7165 416.34 89.5217 414.483 127.138C413.554 145.854 412.225 158.674 413.143 161.385H416.405Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M425.379 91.6169C432.529 82.4153 447.325 75.1361 462.488 74.0237C468.439 73.5809 444.528 85.4501 434.678 97.3085C427.043 106.51 418.478 121.673 415.627 129.946C417.301 112.871 418.219 100.84 425.379 91.6169Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M410.4 89.6297C403.002 79.3265 385.916 71.3885 367.426 70.4921C360.169 70.1465 387.784 83.0849 398.088 96.3473C406.09 106.64 414.288 123.704 416.556 133.067C417.106 113.649 417.808 99.9437 410.4 89.6297Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M424.882 61.2903C430.531 53.6115 443.005 47.3043 456.202 46.0191C461.386 45.5115 441.234 55.7391 433.414 65.6967C427.334 73.3863 420.876 85.9683 418.932 92.7831C419.256 78.8187 419.245 68.9691 424.882 61.2903Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M413.51 62.8678C407.235 54.1306 392.774 47.4238 377.114 46.6678C370.969 46.3762 394.394 57.3274 403.034 68.5594C409.816 77.275 416.772 91.7254 418.683 99.6526C419.18 83.1934 419.774 71.5942 413.51 62.8678Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M421.092 126.264C425.175 120.475 434.344 115.604 444.14 114.438C447.984 113.984 433.167 121.922 427.508 129.406C423.112 135.217 418.5 144.656 417.161 149.743C417.172 139.364 417.021 132.052 421.092 126.264Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M413.64 123.002C410.097 117.256 401.328 112.407 391.554 111.24C387.709 110.787 401.879 118.682 406.857 126.101C410.713 131.868 414.417 141.221 415.281 146.276C416.34 135.994 417.225 128.747 413.64 123.002Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M415.077 191.172C422.885 191.172 429.333 189.541 429.776 181.754L431.082 159.215H399.082L400.389 181.754C400.832 189.541 407.279 191.172 415.077 191.172Z",
			fill: "#E6E6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M399.265 164.344H430.92C431.539 164.342 432.136 164.112 432.596 163.698C433.057 163.283 433.348 162.714 433.414 162.098L433.9 157.778C433.938 157.426 433.902 157.07 433.793 156.733C433.685 156.396 433.506 156.085 433.27 155.821C433.034 155.558 432.745 155.347 432.422 155.202C432.099 155.057 431.749 154.981 431.395 154.98H398.79C398.436 154.981 398.086 155.057 397.763 155.202C397.44 155.347 397.151 155.558 396.914 155.821C396.678 156.085 396.5 156.396 396.391 156.733C396.283 157.07 396.246 157.426 396.284 157.778L396.759 162.098C396.828 162.714 397.122 163.284 397.584 163.699C398.046 164.113 398.644 164.343 399.265 164.344Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M297.27 191.172H276.048L282.333 144.656H297.27V191.172Z",
			fill: "#E6E6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M328.418 191.171H288.198L280.703 136.729H320.933L328.418 191.171Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M333.785 191.171H291.935L284.45 136.729H326.3L333.785 191.171Z",
			fill: "#F5F5F5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M295.628 186.884L289.321 141.017H322.596L328.903 186.884H295.628Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M314.388 176.3H306.461C305.771 176.301 305.105 176.053 304.584 175.6C304.064 175.147 303.726 174.521 303.632 173.838L301.018 154.841C300.96 154.437 300.99 154.025 301.105 153.634C301.221 153.242 301.42 152.88 301.688 152.573C301.959 152.267 302.291 152.023 302.664 151.856C303.036 151.688 303.439 151.601 303.848 151.601H311.775C312.464 151.602 313.129 151.851 313.649 152.304C314.169 152.756 314.508 153.381 314.604 154.063L317.218 173.06C317.274 173.464 317.242 173.875 317.125 174.266C317.008 174.656 316.809 175.017 316.541 175.324C316.273 175.632 315.942 175.878 315.571 176.046C315.199 176.214 314.796 176.301 314.388 176.3ZM304.668 173.687C304.728 174.111 304.939 174.5 305.262 174.782C305.586 175.064 306 175.219 306.429 175.22H314.356C314.609 175.221 314.86 175.168 315.091 175.063C315.322 174.959 315.528 174.806 315.695 174.615C315.861 174.423 315.985 174.197 316.057 173.953C316.13 173.709 316.15 173.453 316.116 173.201L313.503 154.214C313.443 153.79 313.232 153.401 312.909 153.119C312.585 152.837 312.171 152.682 311.742 152.681H303.815C303.561 152.678 303.31 152.731 303.079 152.836C302.848 152.94 302.642 153.093 302.476 153.285C302.307 153.474 302.181 153.697 302.108 153.94C302.035 154.183 302.017 154.439 302.055 154.689L304.668 173.687Z",
			fill: "#F5F5F5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M228.42 12.5508H68.1699V181.657H228.42V12.5508Z",
			fill: "#E6E6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M245.603 7.0752H57.8015C57.5921 7.07519 57.3848 7.11661 57.1915 7.19707C56.9981 7.27753 56.8226 7.39544 56.6751 7.544C56.5275 7.69257 56.4108 7.86886 56.3316 8.06273C56.2525 8.25659 56.2125 8.46421 56.2139 8.6736C56.2139 9.09466 56.3812 9.49847 56.6789 9.7962C56.9766 10.0939 57.3804 10.2612 57.8015 10.2612H245.603C246.024 10.2612 246.428 10.0939 246.725 9.7962C247.023 9.49847 247.19 9.09466 247.19 8.6736C247.192 8.46421 247.152 8.25659 247.073 8.06273C246.993 7.86886 246.877 7.69257 246.729 7.544C246.582 7.39544 246.406 7.27753 246.213 7.19707C246.019 7.11661 245.812 7.07519 245.603 7.0752Z",
			fill: "#E6E6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M235.235 12.5508H71.3555V181.657H235.235V12.5508Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M225.709 172.142V22.0762L80.8702 22.0762V172.142H225.709Z",
			fill: "#FAFAFA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M113.746 172.142L169.625 22.0654H195.999L140.13 172.142H113.746Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M145.789 172.142L201.668 22.0654H211.95L156.071 172.142H145.789Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M225.709 172.131V22.0654H224.499V172.131H225.709Z",
			fill: "#E6E6E6"
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .6,
			children: [
				/* @__PURE__ */ _jsx("path", {
					opacity: .6,
					d: "M76.9388 246.716H56.8184L60.0044 4.23438H80.1356L76.9388 246.716Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .6,
					d: "M84.7793 246.716H69.0977L72.2945 4.23438H87.9653L84.7793 246.716Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .6,
					d: "M97.0589 246.716H76.9385L80.1353 4.23438H100.256L97.0589 246.716Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .6,
					d: "M104.9 246.716H89.2188L92.4155 4.23438H108.097L104.9 246.716Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .6,
					d: "M117.18 246.716H97.0596L100.256 4.23438H120.377L117.18 246.716Z",
					fill: "#F0F0F0"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .6,
			children: [
				/* @__PURE__ */ _jsx("path", {
					opacity: .6,
					d: "M231.909 246.716H243.282L244.804 4.23438H233.432L231.909 246.716Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .6,
					d: "M227.48 246.716H236.336L237.87 4.23438H229.003L227.48 246.716Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .6,
					d: "M220.536 246.716H231.909L233.431 4.23438H222.059L220.536 246.716Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .6,
					d: "M216.108 246.716H224.964L226.498 4.23438H217.631L216.108 246.716Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .6,
					d: "M209.164 246.716H220.536L222.059 4.23438H210.687L209.164 246.716Z",
					fill: "#F0F0F0"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M270 375.765C385.649 375.765 479.401 370.291 479.401 363.539C479.401 356.787 385.649 351.313 270 351.313C154.351 351.313 60.5986 356.787 60.5986 363.539C60.5986 370.291 154.351 375.765 270 375.765Z",
			fill: "#F5F5F5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M307.39 42.2929C300.91 33.5233 302.411 25.8661 307.39 20.3581C313.6 13.4461 323.741 13.5001 330.502 17.0317C341.086 22.5505 343.364 46.7317 325.685 50.1445C319.412 47.9545 313.299 45.331 307.39 42.2929Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M328.438 18.5543C334.918 14.7419 333.115 7.34393 338.968 3.43433C347.112 -1.96567 364.662 0.377934 359.175 13.8779C353.689 27.3779 373.215 28.1555 367.545 41.5691C361.875 54.9827 345.405 63.1691 341.172 43.7291C338.007 29.1599 351.453 10.3895 340.599 12.4091C333.828 13.6619 331.571 20.6279 331.571 20.6279L328.438 18.5543Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M312.336 75.7293C311.45 78.1809 310.489 80.4057 309.463 82.7061C308.437 85.0065 307.303 87.2205 306.115 89.4345C303.724 94.0807 300.72 98.3851 297.184 102.233C296.173 103.31 295.062 104.29 293.868 105.159C292.687 105.997 291.428 106.721 290.11 107.319C287.68 108.406 285.147 109.246 282.55 109.825C277.628 110.962 272.589 111.509 267.538 111.456C266.971 111.446 266.427 111.232 266.006 110.852C265.585 110.473 265.316 109.953 265.249 109.39C265.182 108.828 265.321 108.259 265.64 107.791C265.96 107.323 266.438 106.987 266.987 106.844H267.095C271.613 105.788 276.06 104.45 280.411 102.837C282.457 102.075 284.436 101.147 286.33 100.062C287.173 99.5782 287.975 99.0255 288.727 98.4093C289.455 97.8005 290.127 97.1283 290.736 96.4005C292.127 94.7568 293.381 93.0013 294.484 91.1517C295.65 89.2401 296.773 87.2637 297.81 85.2009C299.862 81.1185 301.806 76.7553 303.48 72.5649V72.5001C303.924 71.3358 304.812 70.3955 305.95 69.8861C307.087 69.3767 308.38 69.3399 309.544 69.7839C310.709 70.2279 311.649 71.1162 312.158 72.2535C312.668 73.3907 312.704 74.6838 312.26 75.8481L312.336 75.7293Z",
			fill: "#B55B52"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M310.932 67.7374C302.012 68.7526 297.098 82.1338 297.098 82.1338L306.234 95.0074C306.234 95.0074 317.034 82.771 317.974 77.3062C318.914 71.6794 317.52 66.9706 310.932 67.7374Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M306.05 75.9235C309.042 74.0443 312.303 75.0811 315.079 78.5695C315.653 79.5706 316.038 80.669 316.213 81.8095C313.513 86.7019 306.223 94.9963 306.223 94.9963L302.044 89.1103C301.73 85.6327 304.117 77.0791 306.05 75.9235Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M269.169 107.319L262.44 103.69L262.257 112.46C262.257 112.46 266.75 113.432 269.72 111.034L269.169 107.319Z",
			fill: "#B55B52"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M255.69 103.993L256.868 111.153L262.3 112.46L262.484 103.69L255.69 103.993Z",
			fill: "#B55B52"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M289.602 88.2144L283.705 83.376L243.529 143.737L249.48 148.576C256.262 154.127 270.745 145.12 281.88 128.444C293.015 111.769 296.385 93.7656 289.602 88.2144Z",
			fill: "#fad504"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M289.602 88.2144L283.705 83.376L243.529 143.737L249.48 148.576C256.262 154.127 270.745 145.12 281.88 128.444C293.015 111.769 296.385 93.7656 289.602 88.2144Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M276.948 121.99C287.666 105.049 290.389 87.5405 283.03 82.8846C275.671 78.2286 261.016 88.188 250.298 105.129C239.579 122.071 236.857 139.579 244.216 144.235C251.575 148.891 266.23 138.932 276.948 121.99Z",
			fill: "#fad504"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M281.934 103.41C282.734 98.118 281.934 93.8736 279.429 91.7892C273.91 87.264 262.149 94.608 253.066 108.184C249.248 113.775 246.431 119.988 244.739 126.544C245.668 120.344 248.746 112.709 253.617 105.376C262.656 91.8 274.461 84.4668 279.98 88.9812C282.96 91.4112 283.5 96.822 281.934 103.41Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M360.234 304.755L351.162 305.619L346.54 284.483L355.612 283.619L360.234 304.755Z",
			fill: "#B55B52"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M410.767 291.686L402.333 294.991L394.2 274.946L402.635 271.642L410.767 291.686Z",
			fill: "#B55B52"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M399.881 290.844L409.125 286.244C409.285 286.165 409.467 286.145 409.639 286.189C409.811 286.232 409.962 286.336 410.065 286.481L414.752 293.274C414.871 293.45 414.95 293.65 414.985 293.859C415.02 294.068 415.009 294.283 414.954 294.488C414.899 294.693 414.8 294.883 414.665 295.046C414.529 295.21 414.36 295.342 414.169 295.434C410.929 296.99 409.503 297.756 405.432 299.754C402.926 300.996 397.343 303.923 393.887 305.64C390.431 307.358 388.551 304.031 389.837 303.005C395.593 298.415 397.494 294.948 398.757 292.043C398.98 291.524 399.377 291.1 399.881 290.844Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M349.391 300.909H360.299C360.494 300.91 360.683 300.975 360.838 301.094C360.992 301.213 361.102 301.38 361.152 301.568L363.528 310.208C363.588 310.412 363.598 310.627 363.559 310.836C363.52 311.044 363.432 311.241 363.303 311.409C363.173 311.577 363.006 311.713 362.814 311.804C362.623 311.896 362.412 311.941 362.2 311.936C358.388 311.871 356.562 311.936 351.767 311.936H337.122C333.137 311.936 332.262 307.897 333.882 307.54C341.28 305.899 345.546 303.642 347.825 301.492C348.252 301.102 348.813 300.893 349.391 300.909Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M346.551 284.494L348.927 295.38H358.193L355.623 283.619L346.551 284.494Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M402.635 271.652L394.2 274.957L398.401 285.282L406.825 281.977L402.635 271.652Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M338.624 58.6113C345.838 57.7797 350.504 61.2141 350.828 68.4177C351.778 93.8085 354.586 99.6513 358.831 112.784L322.856 122.796C310.069 95.1045 305.576 82.0473 304.15 75.9021C303.854 74.4739 304.033 72.9879 304.661 71.6714C305.289 70.3548 306.331 69.2803 307.628 68.6121C317.204 63.278 327.736 59.8798 338.624 58.6113Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M327.683 41.5908C328.115 47.1312 329.552 56.7108 334.163 59.2488C334.163 59.2488 333.483 62.6724 321.56 74.088C314.205 67.8888 317.963 63.7308 317.963 63.7308C323.439 60.696 322.154 56.7432 319.994 52.9308L327.683 41.5908Z",
			fill: "#B55B52"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M326.851 42.833C327.638 45.9817 327.748 49.2614 327.175 52.4558C326.765 54.6158 324.41 56.2574 321.775 57.197C321.416 55.6966 320.825 54.2611 320.025 52.9418L326.851 42.833Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M329.8 31.1258C331.56 40.079 332.5 43.8266 329.238 49.4858C324.324 58.0394 312.941 58.2554 308.535 50.0042C304.571 42.5846 302.346 29.1926 310.057 23.4254C311.753 22.1474 313.748 21.3244 315.852 21.0345C317.955 20.7447 320.098 20.9976 322.076 21.7692C324.055 22.5408 325.803 23.8056 327.155 25.4432C328.506 27.0809 329.417 29.037 329.8 31.1258Z",
			fill: "#B55B52"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M334.476 36.5794C334.607 37.4427 334.566 38.3234 334.355 39.1706C334.143 40.0179 333.766 40.8147 333.244 41.515C331.84 43.3834 329.724 42.4762 328.924 40.435C328.212 38.5774 328.071 35.359 330.058 34.2358C330.493 33.9974 330.98 33.8707 331.476 33.8673C331.972 33.8638 332.461 33.9837 332.899 34.2161C333.337 34.4485 333.711 34.7862 333.986 35.1987C334.261 35.6112 334.429 36.0857 334.476 36.5794Z",
			fill: "#B55B52"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M321.948 26.3844C321.614 29.808 324.357 35.6616 329.508 37.0224C334.844 30.888 331.323 22.4748 326.42 22.302C321.516 22.1292 321.948 26.3844 321.948 26.3844Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M314.755 17.0529C306.882 17.4093 298.436 20.9193 301.363 33.2529C308.232 31.8165 327.348 29.6781 328.816 24.7749C326.883 18.4785 319.917 16.8153 314.755 17.0529Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M322.856 122.796C322.856 122.796 320.761 195.459 326.603 222.88C332.662 251.413 346.346 292.194 346.346 292.194L359.198 291.363C359.198 291.363 350.892 238.043 348.398 216.043C344.877 185.717 349.251 115.441 349.251 115.441L322.856 122.796Z",
			fill: "#407BFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M340.956 145.519C341.539 138.931 346.507 140.194 347.62 149.115C347.134 163.155 346.788 179.452 347.069 193.719C341.712 183.254 339.628 160.509 340.956 145.519Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M360.828 292.194L345.351 293.242L343.202 285.984L359.953 284.213L360.828 292.194Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M335.545 119.264C335.545 119.264 346.496 180.176 361.368 212.954C373.377 239.425 395.139 282.074 395.139 282.074L406.944 277.657C406.944 277.657 388.487 229.241 381.812 210.621C365.191 164.181 374.252 135.993 358.83 112.784L335.545 119.264Z",
			fill: "#407BFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M408.338 278.781L394.719 283.522L390.842 276.545L407.053 272.527L408.338 278.781Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M358.776 110.56L361.303 113.335C361.498 113.551 361.303 113.886 360.85 113.994L323.125 124.502C322.801 124.589 322.488 124.502 322.413 124.308L321.192 121.176C321.106 120.96 321.333 120.69 321.689 120.593L358.117 110.452C358.227 110.409 358.346 110.397 358.462 110.416C358.577 110.435 358.686 110.484 358.776 110.56Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M355.018 115.96L356.001 115.679C356.195 115.625 356.314 115.484 356.26 115.366L354.64 111.316C354.64 111.197 354.402 111.143 354.208 111.197L353.225 111.467C353.031 111.467 352.912 111.661 352.955 111.78L354.586 115.841C354.629 115.96 354.824 116.014 355.018 115.96Z",
			fill: "#407BFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M325.966 124.038L326.949 123.768C327.133 123.768 327.262 123.573 327.208 123.454L325.588 119.404C325.588 119.286 325.34 119.232 325.145 119.286L324.173 119.556C323.979 119.556 323.86 119.75 323.903 119.869L325.523 123.93C325.577 124.048 325.772 124.092 325.966 124.038Z",
			fill: "#407BFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M340.492 119.999L341.474 119.729C341.669 119.675 341.788 119.534 341.734 119.415L340.114 115.355C340.114 115.236 339.865 115.182 339.671 115.236L338.699 115.506C338.504 115.506 338.386 115.711 338.429 115.83L340.06 119.88C340.103 119.999 340.297 120.053 340.492 119.999Z",
			fill: "#407BFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M317.078 37.1192C317.261 37.8428 317.078 38.5232 316.57 38.642C316.062 38.7608 315.566 38.2856 315.382 37.562C315.198 36.8384 315.382 36.1688 315.89 36.0392C316.397 35.9096 316.894 36.374 317.078 37.1192Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M308.966 39.2144C309.161 39.9272 308.966 40.6076 308.459 40.7372C307.951 40.8668 307.454 40.37 307.271 39.6572C307.087 38.9444 307.271 38.2532 307.778 38.1344C308.286 38.0156 308.783 38.4908 308.966 39.2144Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M307.994 38.1243L306.147 38.0703C306.147 38.0703 307.379 39.1935 307.994 38.1243Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M311.44 39.8848C311.228 41.6883 310.77 43.4543 310.079 45.1336C310.512 45.2995 310.977 45.3682 311.44 45.3346C311.903 45.301 312.353 45.166 312.758 44.9392L311.44 39.8848Z",
			fill: "#A02724"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M315.932 47.1097C315.891 47.1024 315.853 47.0833 315.822 47.0545C315.791 47.0257 315.77 46.9886 315.76 46.9477C315.752 46.9207 315.749 46.8924 315.752 46.8644C315.756 46.8365 315.765 46.8095 315.779 46.7852C315.793 46.7609 315.812 46.7398 315.835 46.7231C315.858 46.7065 315.883 46.6947 315.911 46.6885C316.809 46.4758 317.644 46.0538 318.348 45.4569C319.052 44.8601 319.604 44.1053 319.961 43.2541C319.969 43.2259 319.984 43.1998 320.002 43.1774C320.021 43.1549 320.045 43.1365 320.071 43.1234C320.097 43.1102 320.126 43.1026 320.155 43.1009C320.185 43.0993 320.214 43.1036 320.242 43.1137C320.294 43.1333 320.338 43.1717 320.364 43.2216C320.39 43.2715 320.396 43.3293 320.382 43.3837C320.01 44.3033 319.424 45.1211 318.673 45.769C317.921 46.417 317.026 46.8766 316.062 47.1097C316.02 47.1223 315.975 47.1223 315.932 47.1097Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M318.665 33.8793C318.588 33.8694 318.516 33.8354 318.459 33.7821C318.04 33.4311 317.543 33.1852 317.01 33.0649C316.476 32.9447 315.922 32.9536 315.392 33.0909C315.282 33.1252 315.163 33.115 315.06 33.0626C314.957 33.0101 314.878 32.9195 314.841 32.8101C314.821 32.7564 314.812 32.699 314.815 32.6416C314.818 32.5842 314.832 32.528 314.857 32.4764C314.883 32.4248 314.918 32.3789 314.962 32.3416C315.006 32.3043 315.057 32.2763 315.111 32.2593C315.78 32.0779 316.482 32.0598 317.158 32.2064C317.835 32.353 318.466 32.66 318.999 33.1017C319.072 33.1631 319.122 33.246 319.144 33.3382C319.165 33.4305 319.157 33.5272 319.119 33.6143C319.082 33.7013 319.018 33.774 318.936 33.8217C318.854 33.8694 318.759 33.8896 318.665 33.8793Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M304.139 36.4502H304.053C303.999 36.432 303.949 36.4032 303.906 36.3656C303.863 36.328 303.828 36.2822 303.803 36.231C303.778 36.1798 303.763 36.1242 303.76 36.0673C303.756 36.0103 303.764 35.9533 303.783 35.8994C303.993 35.2397 304.359 34.6403 304.85 34.1516C305.34 33.6629 305.941 33.2993 306.601 33.0914C306.657 33.0768 306.714 33.0734 306.771 33.0813C306.828 33.0892 306.882 33.1082 306.932 33.1374C306.981 33.1665 307.024 33.2051 307.058 33.251C307.092 33.2969 307.117 33.3491 307.131 33.4046C307.157 33.5177 307.137 33.6365 307.077 33.7354C307.016 33.8344 306.919 33.9056 306.807 33.9338C306.294 34.1091 305.83 34.4044 305.454 34.7951C305.079 35.1859 304.802 35.6608 304.647 36.1802C304.61 36.2797 304.538 36.3621 304.444 36.4119C304.351 36.4617 304.242 36.4753 304.139 36.4502Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M346.41 75.611C343.602 81.3998 340.686 87.0806 337.608 92.729C336.074 95.5586 334.541 98.3882 332.91 101.175C331.279 103.961 329.67 106.758 327.737 109.555C327.294 110.247 326.743 110.981 326.225 111.715L326.03 111.975L325.933 112.115L325.771 112.32C325.544 112.601 325.318 112.839 325.091 113.076C324.678 113.495 324.234 113.881 323.762 114.232C322.207 115.369 320.517 116.309 318.73 117.029C315.576 118.302 312.326 119.321 309.01 120.075C302.661 121.542 296.215 122.549 289.721 123.088L288.986 118.487C292 117.688 295.067 116.845 298.08 115.971C301.093 115.096 304.085 114.167 307.001 113.152C309.84 112.195 312.614 111.055 315.306 109.739C316.441 109.18 317.509 108.495 318.492 107.698C318.653 107.564 318.801 107.416 318.935 107.255C318.974 107.207 319.01 107.156 319.043 107.104L319.28 106.737C319.658 106.143 320.047 105.581 320.436 104.911C321.97 102.33 323.482 99.5654 324.95 96.8006L329.324 88.409L337.964 71.4746L346.41 75.611Z",
			fill: "#B55B52"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M291.946 118.53L285.585 116.089L286.125 125.064C286.125 125.064 291.125 125.064 293.437 121.986L291.946 118.53Z",
			fill: "#B55B52"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M280.584 116.348L279.224 122.947L286.125 125.064L285.585 116.089L280.584 116.348Z",
			fill: "#B55B52"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M338.58 63.2559C335.027 64.8867 330.901 79.6503 330.901 79.6503L346.291 81.3999C346.291 81.3999 349.272 74.2287 348.667 70.5459C347.76 64.6599 342.63 61.3983 338.58 63.2559Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M395.28 293.479C395.221 293.377 395.174 293.269 395.14 293.155C395.09 293.035 395.074 292.903 395.093 292.773C395.112 292.644 395.165 292.522 395.248 292.421C395.993 291.514 399.298 291.881 399.665 291.924C399.708 291.927 399.748 291.943 399.781 291.97C399.814 291.998 399.838 292.034 399.849 292.075C399.863 292.115 399.864 292.158 399.852 292.199C399.841 292.24 399.817 292.276 399.784 292.302C398.844 293.091 397.095 294.354 395.972 294.03C395.824 293.992 395.686 293.924 395.567 293.829C395.448 293.734 395.35 293.615 395.28 293.479ZM399.093 292.302C397.764 292.194 395.982 292.216 395.583 292.691C395.552 292.742 395.536 292.799 395.536 292.858C395.536 292.917 395.552 292.975 395.583 293.026C395.614 293.163 395.681 293.289 395.775 293.393C395.87 293.497 395.989 293.575 396.123 293.62C396.717 293.793 397.818 293.307 399.114 292.302H399.093Z",
			fill: "#407BFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M396.09 290.498C396.049 290.419 396.016 290.336 395.993 290.25C395.948 290.082 395.961 289.905 396.03 289.746C396.098 289.587 396.219 289.457 396.371 289.375C396.512 289.283 396.67 289.223 396.836 289.199C397.002 289.174 397.171 289.187 397.332 289.234C398.617 289.58 399.805 291.945 399.859 292.042C399.878 292.075 399.888 292.112 399.888 292.15C399.888 292.188 399.878 292.226 399.859 292.258C399.838 292.29 399.809 292.315 399.775 292.332C399.741 292.349 399.703 292.357 399.665 292.356C398.291 292.18 397.024 291.521 396.09 290.498ZM399.233 291.805C398.79 291.027 397.97 289.85 397.214 289.645C397.114 289.613 397.009 289.604 396.906 289.619C396.803 289.634 396.705 289.672 396.619 289.731C396.382 289.882 396.382 290.023 396.414 290.12C396.576 290.746 398.175 291.621 399.266 291.848L399.233 291.805Z",
			fill: "#407BFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M344.52 302.703C343.764 302.764 343.009 302.586 342.36 302.195C342.189 302.072 342.05 301.909 341.954 301.722C341.858 301.534 341.809 301.326 341.809 301.115C341.794 301.001 341.811 300.884 341.859 300.779C341.907 300.674 341.983 300.585 342.079 300.521C343.062 299.851 346.777 301.536 347.479 301.882C347.521 301.902 347.557 301.934 347.58 301.975C347.603 302.015 347.613 302.062 347.609 302.109C347.603 302.153 347.583 302.195 347.552 302.228C347.521 302.261 347.48 302.284 347.436 302.292C346.481 302.531 345.504 302.668 344.52 302.703ZM342.781 300.823C342.631 300.814 342.481 300.848 342.349 300.921C342.349 300.921 342.263 300.996 342.273 301.126C342.276 301.267 342.312 301.406 342.378 301.532C342.443 301.657 342.537 301.766 342.651 301.849C343.289 302.335 344.811 302.4 346.755 302.033C345.511 301.431 344.182 301.023 342.813 300.823H342.781Z",
			fill: "#407BFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M347.49 302.335H347.404C346.173 301.838 343.689 299.84 343.829 298.814C343.829 298.587 344.013 298.307 344.574 298.242C346.734 297.983 347.663 301.925 347.706 302.087C347.713 302.126 347.709 302.166 347.696 302.204C347.683 302.242 347.66 302.276 347.631 302.303C347.589 302.328 347.539 302.34 347.49 302.335ZM344.779 298.641H344.628C344.401 298.641 344.283 298.739 344.261 298.847C344.185 299.441 345.903 301.007 347.155 301.698C346.864 300.758 346.086 298.641 344.779 298.641Z",
			fill: "#407BFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M316.106 36.0391H314.248C314.248 36.0391 315.49 37.1191 316.106 36.0391Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M320.35 311.947H379.448C379.854 311.947 380.244 312.109 380.532 312.396C380.82 312.684 380.981 313.074 380.981 313.481V318.47H318.827V313.481C318.827 313.076 318.987 312.688 319.273 312.4C319.558 312.113 319.945 311.95 320.35 311.947Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M381.51 334.983H319.356V341.496H381.51V334.983Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M381.51 334.983H340.416V341.496H381.51V334.983Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M346.399 318.459L339.411 362.199C339.353 362.559 339.169 362.886 338.892 363.123C338.616 363.361 338.264 363.492 337.899 363.495H334.476C334.255 363.495 334.036 363.446 333.835 363.354C333.634 363.261 333.456 363.126 333.313 362.957C333.169 362.789 333.063 362.592 333.003 362.379C332.943 362.166 332.93 361.943 332.964 361.724L339.887 318.416L346.399 318.459Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M346.399 318.46L345.87 321.786H339.347L339.887 318.46H346.399Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M325.339 318.459L318.352 362.199C318.293 362.559 318.109 362.886 317.833 363.123C317.556 363.361 317.204 363.492 316.84 363.495H313.416C313.195 363.495 312.977 363.446 312.776 363.354C312.575 363.261 312.397 363.126 312.253 362.957C312.109 362.789 312.004 362.592 311.944 362.379C311.883 362.166 311.87 361.943 311.904 361.724L318.827 318.416L325.339 318.459Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M387.893 361.768L380.981 318.46H374.501L381.456 362.2C381.513 362.561 381.696 362.889 381.973 363.127C382.25 363.364 382.603 363.495 382.968 363.496H386.381C386.598 363.495 386.812 363.447 387.01 363.357C387.207 363.267 387.383 363.136 387.526 362.972C387.669 362.809 387.775 362.617 387.839 362.409C387.902 362.202 387.92 361.983 387.893 361.768Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M381.51 321.786L380.981 318.46H374.458L374.987 321.786H381.51Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M366.833 361.768L359.921 318.46H353.441L360.397 362.2C360.453 362.561 360.636 362.889 360.914 363.127C361.191 363.364 361.544 363.495 361.909 363.496H365.321C365.538 363.495 365.753 363.447 365.95 363.357C366.147 363.267 366.323 363.136 366.466 362.972C366.609 362.809 366.716 362.617 366.779 362.409C366.842 362.202 366.861 361.983 366.833 361.768Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M366.833 361.768L359.921 318.46H353.441L360.397 362.2C360.453 362.561 360.636 362.889 360.914 363.127C361.191 363.364 361.544 363.495 361.909 363.496H365.321C365.538 363.495 365.753 363.447 365.95 363.357C366.147 363.267 366.323 363.136 366.466 362.972C366.609 362.809 366.716 362.617 366.779 362.409C366.842 362.202 366.861 361.983 366.833 361.768Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M339.887 311.947H379.447C379.854 311.947 380.244 312.109 380.532 312.396C380.819 312.684 380.981 313.074 380.981 313.481V318.47H339.941V311.99L339.887 311.947Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M157.443 357.589L166.094 341.713L135.152 314.594L132.732 357.589H157.443Z",
			fill: "#407BFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M157.443 357.589L166.094 341.713L135.152 314.594L132.732 357.589H157.443Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M264.082 176.677C281.438 164.797 295.974 166.018 300.802 169.484C305.63 172.951 290.294 199.282 290.294 199.282C284.558 197.616 279.249 194.734 274.726 190.834C270.203 186.934 266.573 182.105 264.082 176.677Z",
			fill: "#407BFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M272.344 188.611C282.118 179.01 292.086 175.932 294.786 177.541C297.486 179.15 288.814 197.662 288.814 197.662C288.814 197.662 277.096 199.346 272.344 188.611Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M113.282 213.916L112.299 213.419C115.012 208.08 118.204 202.997 121.835 198.234L122.71 198.904C119.125 203.616 115.969 208.64 113.282 213.916Z",
			fill: "#407BFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M108.141 226.12L107.061 225.764C107.881 223.355 108.81 220.947 109.825 218.614L110.841 219.057C109.869 221.347 108.951 223.723 108.141 226.12Z",
			fill: "#407BFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M310.079 256.09C310.079 309.712 269.709 353.171 211.432 353.171C153.155 353.171 105.916 309.712 105.916 256.09C105.916 202.468 153.155 159.009 211.432 159.009C269.709 159.009 310.079 202.468 310.079 256.09Z",
			fill: "#407BFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M197.37 342.89L193.147 351.724C196.2 352.221 199.3 352.581 202.446 352.804L197.37 342.89Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M190.977 363.539L203.116 341.713L164.29 327.521L159.322 363.539H190.977Z",
			fill: "#407BFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M247.526 363.539L237.007 341.713L273.975 327.521L276.427 363.539H247.526Z",
			fill: "#407BFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M274.082 270.119C274.082 284.634 261.252 296.396 245.473 296.396C229.694 296.396 216.918 284.634 216.918 270.119C216.918 255.604 229.705 243.843 245.473 243.843C261.241 243.843 274.082 255.604 274.082 270.119Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M235.991 278.716C238.669 278.716 240.84 274.673 240.84 269.687C240.84 264.701 238.669 260.658 235.991 260.658C233.313 260.658 231.142 264.701 231.142 269.687C231.142 274.673 233.313 278.716 235.991 278.716Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .4,
			d: "M201.313 221.109C202.706 225.353 201.421 229.986 198.451 231.444C195.481 232.902 191.971 230.634 190.545 226.39C189.12 222.146 190.426 217.512 193.396 216.054C196.366 214.596 199.92 216.854 201.313 221.109Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .4,
			d: "M276.481 221.303C275.401 225.548 276.729 230.127 279.407 231.52C282.086 232.913 285.11 230.602 286.168 226.347C287.227 222.092 285.92 217.523 283.241 216.13C280.563 214.737 277.561 217.048 276.481 221.303Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M261.793 278.716C264.471 278.716 266.642 274.673 266.642 269.687C266.642 264.701 264.471 260.658 261.793 260.658C259.114 260.658 256.943 264.701 256.943 269.687C256.943 274.673 259.114 278.716 261.793 278.716Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M180.587 175.792C161.784 160.218 144.947 159.009 139.137 161.838C133.326 164.668 148.435 195.2 148.435 195.2C148.435 195.2 169.063 193.99 180.587 175.792Z",
			fill: "#407BFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M170.003 187.002C159.689 175.122 148.543 170.176 145.292 171.407C142.042 172.638 150.282 193.72 150.282 193.72C150.282 193.72 163.566 197.543 170.003 187.002Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .4,
			d: "M218.56 167.454H234.446C234.446 167.454 230.99 163.653 219.262 162.497C212.619 161.957 205.934 162.321 199.39 163.577C199.39 163.577 212.479 163.285 218.56 167.454Z",
			fill: "black"
		})
	]
});
const ForwardRef = forwardRef(SvgBudgetStep6);
export default ForwardRef;
